export const OktaClientId = '0oa15aymctiioGwei697'
export const ENV = 'training1' as string
export const OVERSIGHT_ENV_NAME = 'oversight-training'
export const GCS_ENV_NAME = 'training1'
export const SUBDOMAIN_SUFFIX = 'gcs-training'
